<template>
    <v-layout wrap justify-center id="devtool">
        <v-flex xs5>
            <FindAndDelete :instantEmailSearch="instantEmailSearch" />
        </v-flex>
    </v-layout>
</template>

<script>
import FindAndDelete from '@/components/devtool/FindAndDelete.vue';

export default {
    name: 'Devtool',
    components: {
        FindAndDelete,
    },
    data() {
        return {
            instantEmailSearch: '',
        };
    },
    beforeRouteEnter(to, from, next) {
        const query = to.query || {};
        next((vm) => {
            /* eslint-disable-next-line */
            vm.instantEmailSearch = query.email || {};
        });
    },
};
</script>

<style scoped lang="scss">
</style>
